if (!customElements.get('deployer-upsell')) {
  customElements.define(
    'deployer-upsell',
    class DeployerUpsell extends HTMLElement {
      constructor() {
        super();
        this.selects = this.querySelectorAll('.deployer-select');
        this.variantsData = {};

        this.form = this.querySelector('.deployer-upsell__form form');
        this.formInputs = this.form.querySelectorAll('input');
        this.submitButton = this.form.querySelector('[name="add"]');
        this.discountType = this.dataset.discountType;
        this.dynamicSaving = this.dataset.dynamicSaving;
      }

      connectedCallback() {
        this.selects.forEach((select) => {
          select.addEventListener('change', this.handleSelectChange.bind(this));
        });
      }

      async handleSelectChange() {
        this.submitButton.disabled = true;
        await this.getSelectedVariantsData();
        this.updateBundlePrices();

        this.formInputs.forEach((input) => {
          if (!this.variantsData[input.dataset.handle]) return;
          const variantId = this.variantsData[input.dataset.handle].id;
          input.value = variantId;
        });

        this.submitButton.disabled = false;

        const available = Object.values(this.variantsData).every((variant) => variant.available);
        this.toggleAvailability(available);
        if (this.dataset.dynamicVariantImage === 'false' && parseInt(this.dataset.bundleSize) == 1) {
          this.updateImage();
        }
      }

      updateBundlePrices() {
        const priceContainer = this.querySelector('.deployer-upsell__upsell-price span');
        const compareAtPriceContainer = this.querySelector('.deployer-upsell__upsell-price s');
        // add all of variants prices to get the total price
        const totalPrice = Object.values(this.variantsData).reduce((acc, variant) => acc + variant.price, 0);
        priceContainer.innerText = formatPrice(totalPrice);
        // add all the compare at prices to get the total compare at price
        const totalCompareAtPrice = Object.values(this.variantsData).reduce(
          (acc, variant) => acc + variant.compare_at_price,
          0,
        );
        if (totalCompareAtPrice === 0) return;
        if (compareAtPriceContainer) compareAtPriceContainer.innerText = formatPrice(totalCompareAtPrice);
        if (!this.dynamicSaving) return;
        if (totalCompareAtPrice > totalPrice) {
          this.dynamicSavingContainer = this.querySelector('.deployer-upsell__dynamic-saving');
          if (this.discountType === 'percentage') {
            const discount = Math.round(((totalCompareAtPrice - totalPrice) / totalCompareAtPrice) * 100);
            this.dynamicSavingContainer.innerHTML = `${discount.toFixed(0)}%`;
          } else {
            const discount = totalCompareAtPrice - totalPrice;
            this.dynamicSavingContainer.innerHTML = formatPrice(discount);
          }
        }
      }

      updateImage() {
        const image = this.querySelector('.deployer-upsell__upsell-image');
        const variant = this.variantsData[Object.keys(this.variantsData)[0]];
        if (!variant.featured_image) return;
        image.src = variant.featured_image.src;
      }

      toggleAvailability(available) {
        if (available) {
          this.submitButton.disabled = false;
          this.submitButton.innerText = this.submitButton.dataset.addToCartText;
          return;
        }
        this.submitButton.disabled = true;
        this.submitButton.innerText = this.submitButton.dataset.soldOutText;
      }

      async getSelectedVariantsData() {
        this.variantsData = {};
        for (const select of this.selects) {
          const selectedValue = select[select.selectedIndex].value;
          const variant = await this.fetchVariantData(select.dataset.handle, selectedValue);
          this.variantsData[select.dataset.handle] = variant;
        }
      }

      async fetchVariantData(productHandle, variantId) {
        try {
          const response = await fetch(`/products/${productHandle}.js`);
          const data = await response.json();
          const variant = data.variants.find((variant) => variant.id === parseInt(variantId));
          return variant;
        } catch (error) {
          console.error('Error:', error);
        }
      }
    },
  );
}
